'use strict';

var $ = require('jquery'),
  _ = require('underscore'),
  Backbone = require('backbone'),
  OrderHistoryCollection = require('./OrderHistoryCollection'),
  utilities = require('../../js/utilities'),
  ResultsTemplate = require('./templates/OrderHistoryItem.hbs'),

  OrderHistoryView = Backbone.View.extend({
    template: ResultsTemplate,

    events: {
      'click .Button--loadMore': 'loadMoreResults'
    },

    initialize: function() {
      // Get min and max elements;
      this.$loadedCount = $('.OrderHistoryPage-count').find('span');

      // On load find how many results are already rendered.
      this.min = this.$loadedCount.data('amount');

      this.$list = this.$('.OrderList');

      this.collection = new OrderHistoryCollection();

      Backbone.history.start({
        pushState: Modernizr.history
      });
    },

    loadMoreResults: function() {
      var self = this,
        urlRegex = /page=([0-9]+)/,
        endpoint = this.$list.data('endpoint');

      if (!this.collection.firstFetch) {
        this.currentPage = parseInt(endpoint.match(urlRegex)[1], 10);
      }

      this.currentPage++;
      this.collection.url = endpoint.replace(urlRegex, 'page=' + this.currentPage);

      this.collection.fetch({
        handleErrorLocally: true,
        data: utilities.addCustIpToDataObject({})
      }).success(function(res) {
        self.$list.append(self.template({
          results: self.collection.toJSON()
        }));

        if (!self.collection.firstFetch) {
          delete res.data.orders;
          delete res.data.currentPage;
          _.extend(self, res.data);
          self.collection.firstFetch = true;
        }
        self.updateValues();
      });
    },

    updateValues: function() {
      // Update the results string at the top of the page.
      this.$loadedCount.text(this.min += this.resultsPerPage);
      // Hide the load more button if the results are at the maximum

      if (this.min >= this.totalResults && this.min <= this.maxItems) {
        this.$('.Button--loadMore').hide();
      }
      // this.currentPage will be returned from the JSON.
      Backbone.history.navigate(window.location.pathname + '?page=' + this.currentPage,
        {
          trigger: false,
          replace: true
        }
      );
    }
  },
  {
    create: function($parent) {
      $parent.find('.OrderHistoryPage').each(function(n, el) {
        new OrderHistoryView({
          el: el
        });
      });
    }
  });

module.exports = OrderHistoryView;



// WEBPACK FOOTER //
// ./assets/components/OrderHistory/OrderHistoryView.js